import { Outlet } from "react-router";

import "../Inbox.scss";

export default function InboxMobileLayout() {
  return (
    <div className="d-flex align-items-start flex-direction-column">
      <Outlet />
    </div>
  );
}
